module.exports = __webpack_public_path__ + "img/publicOrder.7c870cce.png";